export default {
  buttons: {
    apply: "Apply",
    cancel: "CANCEL",
    dismiss: "Close",
    minimize: "minimize",
    unminimize: "unminimize",
    add_waypoint: "add a destination",
    navigate: "Navigate",
    send_to_phone: "Send to phone"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "mi"
    }
  },
  send_to_phone: {
    title: "Send to phone",
    copy_link: {
    header: "Copy this link to share",
    button: "Copy link"
    },
    qr_code_header: "Scan this QR code with your phone",
    mail: {
    link: "Send via email",
    header: "Mail",
      subject: "Shell Site Locator: your route to {destination}",
      body: "{url}"
    }
  },
  search: {
    title: "Search",
    placeholder: "Enter a location",
    enter_location: "Enter a location",
    recent_searches: "Recent searches",
    suggestions: "Suggestions",
    geolocation: "Use my location",
    help: {
      inactive: "Search",
      clear: "Clear"
    }
  },
  filters: {
    title: "Filters",
    more: "More Filters",
    less: "Less Filters",
    group: {
      more: "More",
      less: "Less"
    },
    amenities: {
      title: "Services & Amenities"
    },
    fuels: {
      title: "Fuel Types"
    },
    open_statuses: {
      title: "Opening Hours"
    }
  },
  directions: {
    title: "Route planner",
    help: {
      add_waypoint: "Add waypoint",
      reverse: "Reverse Directions",
      sort_waypoint: "Drag to reorder",
      remove: "Remove waypoint"
    },
    placeholder: {
      origin: "Choose starting point",
      destination: "Enter a location",
      waypoint: "Enter a location"
    },
    route: {
      title: "Route Options",
      title_avoid: "Avoid",
      avoid_tolls: "Avoid toll roads",
      avoid_highways: "Avoid motorways",
      avoid_ferries: "Avoid Ferries",
      title_corridor: "Distance from route to service stations"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# day} other {# days}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}
`,
    button: "Search",
    error: "There was a problem processing your route. Please try again"
  },
  action_panel: {
    back_to_results: "Back to Results"
  },
  locations: {
    title: "locations",
    closed_temporarily: "Closed Temporarily",
    distance: "{distance, number, distance} {unit}",
    description: "{visible, select, true {Hide} false {Show} }"
  },
  open_now: {
    open_until: "OPEN NOW: until {statusChangeTime, date, dateFormat}",
    open_24_hours: "Open 24 Hours",
    closed_until: "CLOSED NOW: open from {statusChangeTime, date, dateFormat}"
  },
  info_window: {
    back_to_results: "Back to Results",
    title: "Site details",
    location_id: "Site ID",
    website: "Website",
    services: "Services & Amenities",
    nearby: "Nearby",
    directions: "Add to route planner",
    mobile: {
    telephone: "Tel:"
    },
    opening_hours: {
      title: "Open & Closing Hours",
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
      sun: "Sun",
      open_twentyfourhours: "Open 24 Hours",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Fuel and Pricing Available",
      not_available: "Fuel Available",
      price: "{price, number, fuelPrice}",
      disclaimer: "All information is supplied without guarantee; only the prices at pump are valid.",
      last_updated_on: "Last updated",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Route planner"
  },
  fuels: {
    auto_rv_propane: "Auto RV Propane",
    autogas_lpg: "Autogas LPG",
    cng: "CNG",
    diesel_fit: "Diesel Fit",
    fuelsave_98: "Fuelsave 98",
    fuelsave_midgrade_gasoline: "Shell FuelSave 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel Euro 5",
    gtl: "GTL",
    hydrogen: "Hydrogen",
    lng: "LNG",
    low_octane_gasoline: "Low Octane gasoline",
    midgrade_gasoline: "Midgrade Gasoline",
    premium_diesel: "Premium Diesel",
    premium_gasoline: "Shell V-Power 97",
    shell_regular_diesel: "Shell FuelSave Diesel",
    super98: "Super98",
    super_premium_gasoline: "Shell V-Power Racing",
    truck_diesel: "Truck Diesel",
    unleaded_super: "Unleaded Super",
    kerosene: "Kerosene",
    shell_recharge: "Shell Recharge",
  },
  amenities: {
    air_and_water: "Air",
    atm_in: "ATM-IN",
    atm_out: "ATM-OUT",
    atm: "ATM",
    austrian_highway_sticker: "Austrian Highway Sticker",
    baby_change_facilities: "Baby changing facilites",
    bakery_shop: "Bakery Shop",
    bottled_gas: "BBQ Propane Cylinder Exchange",
    burger: "Burger",
    cafe: "Cafeteria",
    carwash: "Car Wash",
    children_play_area: "Childrens play area",
    childs_toilet: "Water Closet or Toilet - child",
    clubsmart_card: "Shell ClubSmart Card",
    coca_cola_freestyle: "Coca Cola Freestyle",
    conveyor_and_jet: "Conveyor and Jet",
    conveyor: "Conveyor",
    costa_express: "Costa Coffee",
    credit_card_american_express: "Credit Card - American Express",
    credit_card_diners_club: "Credit Card - Diners Club",
    credit_card_general: "Credit card - General",
    credit_card_mastercard: "Credit Card - Mastercard",
    credit_card_visa: "Credit Card - Visa",
    credit_card: "Credit Card",
    czech_highway_sticker: "Czech Highway Sticker",
    deli2go: "deli2go",
    disability_assistance: "Disability Assistance",
    disabled_facilities: "Disabled Facilities",
    euroshell_card: "Shell Card Acceptance",
    fleet_card_dkv: "Firmakort",
    fleet_card_eni: "Fleet Card - Eni",
    fleet_card_esso: "Fleet Card - Esso",
    fleet_card_general: "Fleet Card",
    fleet_card_uta: "Fleet Card - UTA",
    food_offerings: "Food Offerings",
    fuel_card: "Fuel card",
    full_service: "Forecourt Attendants",
    guarded_car_park: "Guarded Parking",
    hgv_lane: "Truck Friendly",
    high_speed_diesel_pump: "High Speed Diesel",
    hot_food: "Hot Food",
    hungarian_highway_sticker: "Hungarian Highway Sticker",
    ido_ticket: "Ido Ticket",
    jet: "Jet wash",
    lottery: "Lottery",
    loyalty_cards: "Bonuslink Redemption",
    manual: "Manual",
    maut_terminal: "Touch & Go",
    mobile_airtime: "Mobile airtime",
    mobile_loyalty: "Mobile Loyalty",
    mobile_payment: "Mobile Payments",
    money_transfer_services: "Money transfer services",
    motorway_service: "Motorway Service",
    navigator_fleet_loyalty_discount: "Loyalty discount",
    oil_and_lubricants: "Oil and lubricants",
    others: "Others",
    parking_lanes: "Parking Lane",
    partner_card: "Partner Card",
    partner_loyalty_accepted: "Partner Loyalty Accepted",
    pay_at_pump: "Pay at Pump",
    pizza: "Pizza",
    prayer_room: "Prayer room",
    quick_lubes: "Oil Change Service",
    restaurant: "Food Oasis",
    rollover_and_jet: "Rollover and Jet",
    rollover: "Rollover",
    sandwich: "Sandwich",
    sconti_bancoposta: "Sconti BancoPosta",
    selectshop: "Shop - Select",
    self_service: "Self Service",
    service_bay: "Service Bays",
    shell_card: "Shell Card Acceptance",
    shell_club_smart_extra_card: "Shell Club Smart Extra Card",
    shop: "Shop",
    shower: "Shower",
    slovak_highway_sticker: "Slovak Highway Sticker",
    snack_food: "Snack Food/Quick Food",
    standard_toilet: "Toilet",
    starbucks: "Starbucks",
    supermarket_fuel_discount: "Fuel Discount",
    telepass_premium: "Telepass Premium",
    tim_hortons: "Tim Hortons",
    toilet: "Toilet",
    truck_parking: "Truck Parking",
    truckport: "Truck Only",
    twenty_four_hour: "24 Hour",
    twotheloo: "2theloo",
    tyre_service: "Tyre service",
    unmanned: "Unmanned",
    utility_payment_services: "Utility payment services",
    vacuum: "Hoover / Vacuum",
    vehicle_identity_system: "Vehicle Identification System",
    waitrose: "Waitrose",
    wifi: "WiFi",
    pizza_hut_express: "Pizza Hut Express",
    budgens: "Budgens",
    deli_cafe: "Deli Cafe",
    amazon_locker: "Amazon Locker",
    deli_by_shell: "Deli By Shell",
    car_wash_mpay: "Car Wash MPay",
    pay_tm: "PayTM",
    adblue_truck: "AdBlue Pump Truck",
    adblue_car: "AdBlue Pump Passenger Vehicles",
    adblue_pack: "AdBlue Packed Product",
    migrolino: "Migrolino",
    spar_express: "Spar Express"
  },
  open_statuses: {
    open_now: "Open now"
  },
  settings: {
    title: "Settings",
    tooltip: "Settings",
    traffic: "Traffic",
    distance_units: {
      title: "Distance",
      km: "kilometers",
      miles: "miles"
    },
    language: {
      title: "Language",
      locales: {
        es_AR: "Spanish",
        en_AU: "English",
        de_AT: "German",
        fr_BE: "French",
        nl_BE: "Dutch",
        pt_BR: "Portugese",
        en_BG: "English",
        bg_BG: "Bulgarian",
        fr_CA: "French",
        en_CA: "English",
        cz_CZ: "Czech",
        da_DK: "Danish",
        fi_FI: "Finnish",
        fr_FR: "French",
        de_DE: "German",
        en_HK: "English",
        zh_HK: "Chinese (traditional)",
        hu_HU: "Hungarian",
        en_IN: "English",
        en_ID: "English",
        id_ID: "Indonesian",
        it_IT: "Italian",
        lv_LV: "Latvian",
        ru_LV: "Russian",
        lt_LT: "Lithuanian",
        fr_LU: "French",
        en_LU: "English",
        en_MY: "English",
        en_MO: "English",
        zh_MO: "Chinese (traditional)",
        es_MX: "Spanish",
        nl_NL: "Dutch",
        nb_NO: "Norwegian (Bokmal)",
        en_OM: "English",
        ar_OM: "Arabic",
        en_PK: "English",
        ur_PK: "Urdu",
        en_PH: "English",
        pl_PL: "Polish",
        es_PR: "Spanish",
        ro_RO: "Romanian",
        ru_RU: "Russian",
        en_SG: "English",
        sk_SK: "Slovak",
        sl_SI: "Slovene",
        en_ZA: "English",
        sv_SE: "Svenska",
        fr_CH: "French",
        de_CH: "German",
        th_TH: "Thai",
        tr_TR: "Turkish",
        uk_UA: "Ukrainian",
        en_GB: "English",
        en_US: "English",
      }
    }
  },
  geolocation: {
    tooltip: "Use my location"
  }
}
